import { render, staticRenderFns } from "./EditTextJustify.vue?vue&type=template&id=515b0e02&scoped=true&"
import script from "./EditTextJustify.vue?vue&type=script&lang=js&"
export * from "./EditTextJustify.vue?vue&type=script&lang=js&"
import style0 from "./EditTextJustify.vue?vue&type=style&index=0&id=515b0e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b0e02",
  null
  
)

export default component.exports